export class OverrideDataClassificationsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dataClasses",
            "baseName": "dataClasses",
            "type": "Array<DataClass>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OverrideDataClassificationsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
